// extracted by mini-css-extract-plugin
export default {"no-results":"styles_no-results__WcyQu"};